/*
 * @Author: your name
 * @Date: 2020-08-21 18:15:16
 * @LastEditTime: 2020-10-13 10:55:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \eunke-st-www\src\router\modules\reportRouter.js
 */
const Main = () => import('@/views/Main.vue')

const reportRouter = {
    path: '/report',
    name: 'Report',
    component: Main,
    icon: require(`@/assets/images/menu-icons/icon_report_20_20.png`),
    icon_active: require(`@/assets/images/menu-icons/icon_report_hover_20_20.png`),
    children: [{
        path: 'waybill-profit',
        name: 'OrderProfit',
        component: () => import('@/views/Report/OrderProfit.vue'),
        meta: {
            title: '订单利润表',
            roles: ['waybill-profit']
        }
    }, {
        path: 'performance',
        name: 'PlatformPerformance',
        component: () => import('@/views/Report/PlatformPerformance.vue'),
        meta: {
            title: '平台业绩情况',
            roles: ['performance']
        }
    }, {
        path: 'increase',
        name: 'UserIncrease',
        component: () => import('@/views/Report/UserIncrease.vue'),
        meta: {
            title: '用户增长情况',
            roles: ['increase']
        }
    },{
        path: 'wxMessageRecored',
        name: 'WxMessageRecored',
        component: () => import('@/views/Report/WxMessageRecored.vue'),
        meta: {
            title: '微信推送记录',
            roles: ['wx-message-recored']
           
        }
    },{
        path: 'CouponDetail',
        name: 'CouponDetail',
        hidden: true,
        component: () => import('@/views/Report/CouponDetail.vue'),
        meta: {
            title: '优惠券明细',
        }
    }],
    meta: {
        title: '报表中心',
        roles: ['report']
    }
}

export default reportRouter